import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class GozareshKoliModel extends BaseModel {
  RouteName = "GozareshKoli";
  protected AuthState: boolean = true;

  public async GetSearch(Mantaghe = "", Hoze = "", Blook = "") {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/search?Mantaghe=${Mantaghe}&Hoze=${Hoze}&Blook=${Blook}`);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
}
